import React, { useState } from "react";
import { Link } from "react-scroll";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import logo from "../assets/logo9.png";

const Navbar = () => {
  let Links = [
    { name: "home" },
    { name: "prices" },
    { name: "gallery" },
    { name: "contact" },
  ];
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className="shadow-md w-full fixed top-0 left-0 z-50">
      <div className="md:flex items-center justify-between bg-white md:px-10 ">
        <div className="cursor-pointer flex items-center font-[Poppins]">
          <span className="text-3xl mr-1">
            <Link to="home" smooth={true} offset={-200} duration={500}>
              <img src={logo} alt="" className="w-full h-full" />
            </Link>
          </span>
        </div>

        <div
          onClick={handleClick}
          className="text-3xl absolute right-8 top-6 cursor-pointer md:hidden"
        >
          {open ? (
            <AiOutlineClose className="text-[#ff0080]" />
          ) : (
            <AiOutlineMenu className="text-[#2f1847]" />
          )}
        </div>
        <nav className="stroke">
          <ul
            className={`md:flex md:items-center md:pb-0 pb-2 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${
              open ? "top-20 " : "top-[-490px]"
            }`}
          >
            {Links.map((link) => (
              <li
                key={link.name}
                className="md:ml-8 text-xl md:my-0 my-7 capitalize"
              >
                <Link
                  to={link.name}
                  hashSpy={true}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={800}
                  activeClass="active"
                  onClick={handleClick}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
